// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"Gpa-z","updatedSizingPrediction":"Hpa-z","recommendedSize":"Ipa-z","predictedSize":"Jpa-z","recommendedSizeCopy":"Kpa-z"};